import { render, staticRenderFns } from "./SmoothrPayDetail.vue?vue&type=template&id=72acfe54"
import script from "./SmoothrPayDetail.vue?vue&type=script&lang=ts"
export * from "./SmoothrPayDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports